// Visual behaviour ported from the original site. Everything that used to
// render content from /api/content is gone — Liquid renders the markup now, so
// this file only carries the effects.
(function () {
  // ---------- Loader ----------
  (function animateLoader() {
    const loader = document.getElementById('loader');
    const percentEl = document.getElementById('loaderPercent');
    // Ausente cuando el splash está apagado o ya se mostró en esta sesión.
    if (!loader || !percentEl || document.documentElement.classList.contains('sin-splash')) return;
    const duration = 1800;
    const start = performance.now();
    let pageLoaded = document.readyState === 'complete';
    window.addEventListener('load', () => { pageLoaded = true; });

    function tick(now) {
      const elapsed = now - start;
      const t = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      let value = Math.round(eased * 100);
      if (t >= 1 && !pageLoaded) value = 99;
      percentEl.textContent = `${value}%`;
      if (t < 1 || (!pageLoaded && value < 100)) {
        requestAnimationFrame(tick);
      } else {
        percentEl.textContent = '100%';
        setTimeout(() => loader.classList.add('done'), 350);
      }
    }
    requestAnimationFrame(tick);
  })();

  // ---------- Scroll progress + header state ----------
  const header = document.getElementById('siteHeader');
  const progressBar = document.getElementById('progressBar');
  if (header && progressBar) {
    const onScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      progressBar.style.width = `${docHeight > 0 ? (scrollTop / docHeight) * 100 : 0}%`;
      // En páginas internas el header ya nace sólido y debe quedarse así;
      // solo la home alterna entre transparente y sólido al hacer scroll.
      if (!header.classList.contains('header-solid')) {
        header.classList.toggle('scrolled', scrollTop > 60);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---------- Mega menu (touch) ----------
  // Touch devices have no hover, so the mega menu opens on tap. Wrapped because
  // anything thrown here would abort the rest of this file.
  try {
    const megaTrigger = document.getElementById('shopMegaTrigger');
    if (megaTrigger && window.matchMedia('(hover: none)').matches) {
      const megaLink = megaTrigger.querySelector(':scope > a');
      megaLink?.addEventListener('click', e => {
        if (!megaTrigger.classList.contains('open')) {
          e.preventDefault();
          megaTrigger.classList.add('open');
        }
      });
      document.addEventListener('click', e => {
        if (!megaTrigger.contains(e.target)) megaTrigger.classList.remove('open');
      });
    }
  } catch (e) {
    console.error('Mega menu:', e);
  }

  // ---------- Mobile nav ----------
  const navToggle = document.getElementById('navToggle');
  const navLinks = document.getElementById('navLinks');

  // El botón se transforma en X y el fondo deja de hacer scroll mientras el
  // panel está abierto.
  function setNav(abierto) {
    navLinks?.classList.toggle('open', abierto);
    navToggle?.classList.toggle('open', abierto);
    navToggle?.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    document.body.classList.toggle('nav-abierto', abierto);
  }

  navToggle?.addEventListener('click', () => setNav(!navLinks.classList.contains('open')));
  navLinks?.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setNav(false)));
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && navLinks?.classList.contains('open')) setNav(false);
  });

  // ---------- Fotos diferidas ----------
  // Las fotos de campaña viven en assets/ y Shopify no las redimensiona: son de
  // 2400px sea cual sea la pantalla. Cargarlas todas de entrada eran ~5 MB en el
  // celular. Se piden 300px antes de asomar, así que el usuario nunca ve el
  // hueco. Sin JS o sin IntersectionObserver, se cargan todas igual.
  const fotosDiferidas = document.querySelectorAll('[data-bg]');
  function cargarFoto(el) {
    const url = el.dataset.bg;
    if (!url) return;
    el.style.backgroundImage = `url(${url})`;
    el.style.backgroundPosition = `center ${el.dataset.bgPos || 50}%`;
    delete el.dataset.bg;
  }

  if ('IntersectionObserver' in window) {
    const bgObserver = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        cargarFoto(entry.target);
        obs.unobserve(entry.target);
      });
    }, { rootMargin: '300px' });
    fotosDiferidas.forEach(el => bgObserver.observe(el));

    // Las secciones que se agregan desde el personalizador también.
    document.addEventListener('shopify:section:load', event => {
      event.target.querySelectorAll('[data-bg]').forEach(el => bgObserver.observe(el));
    });
  } else {
    fotosDiferidas.forEach(cargarFoto);
  }

  // ---------- Reveal on scroll ----------
  const io = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.18 });

  // Cards inside a horizontally scrolling row never enter the viewport on their
  // own, so they would stay at opacity 0 forever. Watch the row instead and
  // reveal everything in it the moment the row itself shows up.
  const ROW_SELECTOR = '[data-list="products"], .product-grid, .insta-grid, .boutique-grid';
  const rowObserver = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.querySelectorAll('.reveal').forEach(el => {
        el.classList.add('in-view');
        io.unobserve(el);
      });
      obs.unobserve(entry.target);
    });
  }, { threshold: 0.1 });

  function observeAll(root) {
    root.querySelectorAll(ROW_SELECTOR).forEach(row => rowObserver.observe(row));
    root.querySelectorAll('.reveal').forEach(el => {
      if (!el.closest(ROW_SELECTOR)) io.observe(el);
    });
  }
  observeAll(document);

  // Sections added from the theme editor need observing too, otherwise they stay
  // invisible while the merchant is editing.
  document.addEventListener('shopify:section:load', event => observeAll(event.target));

  // ---------- Custom cursor ----------
  const cursorDot = document.getElementById('cursorDot');
  if (cursorDot && window.matchMedia('(pointer: fine)').matches) {
    window.addEventListener('mousemove', e => {
      cursorDot.classList.add('active');
      cursorDot.style.left = `${e.clientX}px`;
      cursorDot.style.top = `${e.clientY}px`;
    });
    document.addEventListener('mouseover', e => {
      if (e.target.closest('[data-hover]') || e.target.closest('a,button')) cursorDot.classList.add('hover');
    });
    document.addEventListener('mouseout', e => {
      if (e.target.closest('[data-hover]') || e.target.closest('a,button')) cursorDot.classList.remove('hover');
    });
  }

  // ---------- Hero animated gradient ----------
  const canvas = document.getElementById('heroCanvas');
  if (canvas) {
    const hasPhoto = canvas.closest('.hero-bg')?.classList.contains('has-photo');
    const ctx = canvas.getContext('2d');
    let w, h, t = 0;
    function resize() {
      w = canvas.width = canvas.parentElement.offsetWidth;
      h = canvas.height = canvas.parentElement.offsetHeight;
    }
    resize();
    window.addEventListener('resize', resize);

    const blobs = [
      { x: 0.3, y: 0.65, r: 0.42, c: 'rgba(217,169,75,0.55)', speed: 0.15 },
      { x: 0.7, y: 0.7, r: 0.3, c: 'rgba(232,135,74,0.4)', speed: 0.22 },
      { x: 0.5, y: 0.35, r: 0.25, c: 'rgba(201,59,122,0.22)', speed: 0.11 }
    ];

    function draw() {
      ctx.clearRect(0, 0, w, h);
      if (!hasPhoto) {
        const grad = ctx.createLinearGradient(0, 0, 0, h);
        grad.addColorStop(0, '#0b1a33');
        grad.addColorStop(1, '#12294d');
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, w, h);
      }

      blobs.forEach(b => {
        const bx = (b.x + Math.sin(t * b.speed) * 0.03) * w;
        const by = (b.y + Math.cos(t * b.speed * 0.8) * 0.03) * h;
        const r = b.r * Math.max(w, h);
        const g = ctx.createRadialGradient(bx, by, 0, bx, by, r);
        g.addColorStop(0, b.c);
        g.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(bx, by, r, 0, Math.PI * 2);
        ctx.fill();
      });
      t += 0.01;
      requestAnimationFrame(draw);
    }
    draw();

    window.addEventListener('scroll', () => {
      const hero = document.getElementById('hero');
      if (!hero) return;
      const offset = window.scrollY;
      hero.style.transform = `translateY(${offset * 0.25}px)`;
      hero.style.opacity = `${Math.max(1 - offset / 700, 0)}`;
    }, { passive: true });
  }
})();
